var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddToWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.676,
    height: 53.187,
    viewBox: "0 0 53.676 53.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add_to_wallet",
    "data-name": "add to wallet",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2548",
    "data-name": "Path 2548",
    d: "M53.658,27.55c0,3.428.047,6.7-.017,9.969a4.313,4.313,0,0,1-4.072,4.1c-3.375.08-6.753.021-10.274.021L53.658,27.55",
    transform: "translate(0 0)",
    fill: "rgba(5,26,53,0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2549",
    "data-name": "Path 2549",
    d: "M49.061,12.321h-32.9a4.391,4.391,0,0,1-.688-.03,1.242,1.242,0,0,1-1.082-1.243,1.27,1.27,0,0,1,1.17-1.225c.192-.018.388-.008.583-.008H42.355c.009-.175.02-.282.02-.382C42.353,7.44,42.349,5.44,42.3,3.44A3.507,3.507,0,0,0,37.887.121c-.975.25-1.937.556-2.92.767C29.634,2.036,24.292,3.16,18.955,4.3a17.632,17.632,0,0,0-4.469,1.265,4.921,4.921,0,0,0-2.952,4.783c.037,5.7.027,11.391.019,17.086A14.206,14.206,0,0,1,25.731,41.586c3.16,0,6.321.013,9.481,0a1.38,1.38,0,0,0,.872-.348q8.642-8.391,17.242-16.819a1.2,1.2,0,0,0,.331-.765c.026-2.245.019-4.491.014-6.737-.01-2.917-1.7-4.6-4.61-4.6",
    transform: "translate(0 0)",
    fill: "rgba(5,26,53,0.7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2550",
    "data-name": "Path 2550",
    d: "M11.527,30.134A11.526,11.526,0,1,0,23.053,41.661,11.526,11.526,0,0,0,11.527,30.134m5.828,13H13.027v4.329a1.5,1.5,0,0,1-3,0V43.137H5.7a1.5,1.5,0,0,1,0-3h4.329V35.808a1.5,1.5,0,0,1,3,0v4.329h4.328a1.5,1.5,0,1,1,0,3",
    transform: "translate(0 0)",
    fill: "rgba(5,26,53,0.5)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToWallet);
export default __webpack_public_path__ + "static/media/add_to_wallet.6610fc4978d45b0e70bcc07c06eae68d.svg";
export { ForwardRef as ReactComponent };